import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Table } from 'react-bootstrap';
import UsersRequestService from '../../services/users-request';
import LoginService from '../../services/login';
import { Trans } from 'react-i18next';
import Pagination from 'react-js-pagination';
import { GroupAddOutlined, Edit, Add, Mail, Clear, Check } from '@material-ui/icons';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import Can from 'components/Can';
import Dialog from 'react-bootstrap-dialog';
import Loading from 'components/Loading';
import { useHistory } from 'react-router';
import { TableHelpers } from 'helpers/helpersTable';
import ReactDOMServer from 'react-dom/server'
import UserAvatar from 'components/UserAvatar';
import { User } from 'models/user';
import { DebounceInput } from 'react-debounce-input'

export default function(){
  let dialog;
  const user = JSON.parse(localStorage.getItem('user'));
  const defaultFilters = { per_page: 10, page: 1, __search: "", status: 1 };

  /*const defaultFilters = { 
    per_page: 10, 
    page: 1, 
    fields: 'id,name,lastname,email,phone,profile_id',
    embed: 'profile:id,name',
    __simple_embed: 1,
    __search: "", 
    status: 1 
  };*/

  const [model, setModel] = useState([]);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(defaultFilters);

  const [status, setStatus] = useState([]);
  const [getActive, setGetActive] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false)

  const history = useHistory();

  useEffect(() => {
    Dialog.setOptions({
      defaultOkLabel: "Sim",
      defaultCancelLabel: "Não",
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    getUsers();
  }, [filters]);

  const getUsers = async () => {
    setIsLoading(true);
    //let name = filters.search;
    let filters_aux = {
      ...filters
    };

    delete filters_aux.status;
    delete filters_aux.search;

    /*if (name != "") {
      filters_aux['name'] = `%${name}%`;
    }*/

    if (getActive) {

      let request2 = UsersRequestService.getUsers({ 
        params: { 
          ...filters_aux 
        } 
      });
      request2.then(data => {
        setModel(data.data.data);
        setPagination(data.data.pagination);
      }).finally(() => setIsLoading(false));

    } else {

      await UsersRequestService.getTrashed({ params: { ...filters_aux } })
        .then(response => {
          setModel(response.data.data.data.map(d => {
            return {
              id: d.id,
              name: d.user_name,
              lastname: d.user_lastname,
              email: d.email,
              phone: d.phone,
              profile_name: d.profile_name,
              deleted_at: d.deleted_at
            }
          }));
          setPagination({
            current_page: response.data.data.current_page,
            from: response.data.data.from,
            last_page: response.data.data.last_page,
            next_page: response.data.data.next_page,
            per_page: response.data.data.per_page,
            to: response.data.data.to,
            total: response.data.data.total,
          });
        }).finally(() => setIsLoading(false));
    }
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  const Data = [];

  const renderData = () => {
    model.map((item, k) => {
      Data.push({
        avatar: <UserAvatar user={new User(item)} style={{margin:0}}/>,
        id: item.id,
        name: item.name + ' ' + item.lastname,
        email: item.email,
        profile_name: item.profile_name,
        phone: item.phone ? item.phone : '--',
        actions: generateActionButtons(item)
      });
    });
  };

  const generateActionButtons = (item) => {
    return (
      <>
        {item.deleted_at ?
          <Can do="user.restore" on="App">
            <Button size="sm" variant="success" onClick={() => restoreUser(item)}><Check /></Button>
          </Can>
          :
          <>
            <Can do="user.edit" on="App">
              {/* <Button size="sm" className="btn-add mr-1" href={"/users/show/" + item.id}><Edit /></Button> */}
              <Button size="sm" className="btn-add mr-1" onClick={() => history.push(`/users/show/${item.id}`)}>
                <Edit />
              </Button>
            </Can>
            <Can do="user.send-password-reset" on="App">
              <Button size="sm" variant="info" className="mr-1" onClick={() => { sendResetPasswordMail(item) }}><Mail /></Button>
            </Can>
            <Can do="user.destroy" on="App">
              <Button size="sm" variant="danger" onClick={() => deactivateUser(item)}>
                <Clear />
              </Button>
            </Can>
          </>
        }
      </>
    )
  }

  const sendResetPasswordMail = async ({ email, name }) => {
    const toasConfig = {
      position: "top-right",
      autoClose: 5000,
    }

    dialog.show({
      title: 'Redefinição de senha',
      body: `Tem certeza que deseja enviar um email de redefinição de senha para o usuário ${name}?`,
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(async () => {
          await LoginService.forgotten_password(email)
            .then(() => {
              toast.success(`O Link para redefinir a senha do(a) ${name} foi enviado!`, toasConfig);
            }).catch(() => {
              toast.error(`Ocorreu um erro ao enviar o link para mudança de senha.`, toasConfig);
            })
        })
      ]
    })
  }

  const deactivateUser = async ({id, name}) => {
    dialog.show({
      title: 'Inativar Usuário',
      body: `Tem certeza que deseja inativar o usuário ${name}?`,
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(async () => {
          await UsersRequestService.delete(id)
            .then(() => {
              getUsers();
            })
        })
      ]
    })
  }

  const restoreUser = ({id, name}) => {
    dialog.show({
      title: 'Reativar Usuário',
      body: `Tem certeza  que deseja reativar o usuário ${name}?`,
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(async () => {
          await UsersRequestService.restore(id)
            .then(() => {
              getUsers();
            })
        })
      ]
    })
  }

  const columns = [
    {
      dataField: 'avatar',
      text: '',
      style: {width: 1}
    },
    {
      dataField: 'name',
      text: 'Nome',
      ...TableHelpers.CONFIG_COLUMNS
    },
    {
      dataField: 'email',
      text: 'E-mail',
      ...TableHelpers.CONFIG_COLUMNS
    },
    {
      dataField: 'profile_name',
      text: 'Perfil',
      ...TableHelpers.CONFIG_COLUMNS
    },
    {
      dataField: 'phone',
      text: 'Telefone',
      ...TableHelpers.CONFIG_COLUMNS
    },
    {
      dataField: 'actions',
      text: 'Ações',
      ...TableHelpers.CONFIG_COLUMNS
    },
  ];

  const filterList = [
    /*{
      title: 'Pesquisa',
      width: 4,
      key: '__search',
      as: 'input'
    },*/
    {
      title: 'Status',
      width: 2,
      key: 'status',
      as: 'select',
      select: [
        { id: 1, name: 'Ativo' },
        { id: 0, name: 'Inativo' }
      ]
    }
  ];
  renderData();

  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;
  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  };

  const exportData = () => {
    setIsExporting(true)    

    //let name = filters.search;
    let filters_aux = {
      is_export: 1,
      ...filters
    };

    filters_aux['__status'] = filters_aux.status;

    delete filters_aux.per_page;
    delete filters_aux.page;
    delete filters_aux.search
    delete filters_aux.status

    // if (name != "") {
    //   filters_aux['name'] = `%${name}%`;
    // }

    UsersRequestService.getUsers({ params: { ...filters_aux } })
      .then(({data}) => {
        const { data: users } = data
        let a = document.createElement('a');
        let data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
        let table_div = createTableToExport(users);
        let table_html = escape(ReactDOMServer.renderToString(table_div));
        a.href = data_type + ', ' + table_html;
        a.download = 'users-list.xls';
        a.click();
      })
      .finally(() => setIsExporting(false));
  }  

  const createTableToExport = users => (
    <Table>
      <thead>
        <th>ID</th>
        {columns.map((col, key) => (
          <th key={key}>{col.text}</th>
        ))}
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.id}>
            <td>{user.id}</td>
            <td>{user.name+' '+user.lastname}</td>
            <td>{user.email}</td>
            <td>{user.profile_name}</td>
            <td>{user.phone}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )

  return (
    <>
      <Container fluid>
        <Dialog
          ref={(component) => dialog = component}
        />
        <Row className="mt-4">
          <GroupAddOutlined className="icon-title" />
          <h5 className="title-dashboard">Usuários</h5>
        </Row>
        {/* <Row>
          <MTable 
            isBordered={true}
            isStriped={true}
            tData={[]}
            tColumns={columns}
            loading={isLoading}
            loaderComponent={<Loading page/>}
          />
        </Row> */}
        <Row className="">
          <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
            <Can do="user.create" on="App">
              <Row className="col-12 mt-2 mb-5">
                <Button className="btn-add" onClick={() => {
                  history.push('/users/show');
                }}>
                  <Add /> Criar usuário
                </Button>
              </Row>
            </Can>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Registros por página:</Form.Label>
                  <Form.Control
                    as="select"
                    value={filters.per_page}
                    onChange={(e) =>
                      handleFilterChange({ per_page: e.target.value })
                    }
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Pesquisa:</Form.Label>
                  <DebounceInput
                    element={Form.Control}
                    debounceTimeout={500}
                    value={filters.__search}
                    onChange={({ target }) => {
                      handleFilterChange({ __search: target.value, page: 1 })
                    }}
                  />
                </Form.Group>
              </Col>
              {filterList.map((f, k) => {
                return (
                  <Col md={f.width} key={k}>
                    <Form.Group>
                      <Form.Label>{f.title}</Form.Label>
                      <Form.Control
                        value={filters[f.key] ?? ""}
                        as={f.as}
                        onChange={e => {
                          let reset = false;
                          let value = {};
                          value[f.key] = e.target.value//f.as === 'input' ? e.target.value : e.target.value;

                          if (f.as == 'select') {
                            handleFilterChange({ ...value, __search: "", page: 1 });
                            setGetActive(e.target.value == 1 ? true : false);
                          } else {
                            handleFilterChange(value);
                          }
                        }}>
                        {f.select ? (<>
                          {f.select.map((s, k) => {
                            return (
                              <option key={k} value={s.id}>{s.name}</option>
                            );
                          })}
                        </>) : null}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                );
              })}
              <Col xs="2" className="align-items-end mt-2">
                <Button
                  className="mt-4"
                  disabled={isExporting}
                  onClick={() => exportData()}
                >
                  Exportar
                  <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    style={!isExporting ? { display: 'none' } : {}} 
                  />
                </Button>
              </Col>
            </Row>

            {isLoading ? (<Loading page/>) : (
              <Row className="mt-4">
                <Col className="p-0">
                  <BootstrapTable
                    wrapperClasses={getTamanho(940) ? 'table-responsive' : ''}
                    style={{ width: '100px' }}
                    id="table"
                    className="font-10"
                    keyField="id"
                    data={Data}
                    columns={columns}
                    bordered
                    striped
                    hover
                    condensed
                  />
                  <Row>
                    <Col xs="12" md="6">
                      <Trans i18nKey="label:interpolateShowingRecords">
                        Showing {{ from: pagination.from || '0' }} to{' '}
                        {{ to: pagination.to || '0' }} from{' '}
                        {{ total: pagination.total }} records
                      </Trans>
                    </Col>
                    <Col xs="12" md="6" className="d-flex justify-content-end">
                      <Pagination
                        activePage={parseInt(pagination.current_page)}
                        itemsCountPerPage={parseInt(pagination.per_page)}
                        totalItemsCount={parseInt(pagination.total)}
                        pageRangeDisplayed={isMobile ? 3 : 5}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                        prevPageText="‹"
                        nextPageText="›"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
